// extracted by mini-css-extract-plugin
export default {"container":"Benefit_container__xsDvA","infoContainer":"Benefit_infoContainer__gC9Cl","infoBody":"Benefit_infoBody__xlueB","backgroundImage":"Benefit_backgroundImage__rTCxi"};